module.exports = __webpack_public_path__ + "static/media/190x190px_loggain.6dea9f9a.png";